<!--
 * @Author: huangtian1_v 1246562955@qq.com
 * @Date: 2024-07-18 18:50:34
 * @LastEditors: huangtian1_v 1246562955@qq.com
 * @LastEditTime: 2024-10-23 16:50:32
 * @FilePath: \eshop_activity\src\views\landingPage\components\ServiceItems.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 服务项 -->
<template>
  <div class="service-items">
    <div class="container">
      <div class="top">
        <h1 class="my-title hidden-sm-and-down">
          <div>以上所有美国手机卡套餐，</div>
          <strong>均包含以下服务</strong>
        </h1>
        <h1 class="my-title hidden-sm-and-up">
          <div>所有套餐，</div>
          <strong>均包含以下服务</strong>
        </h1>
        <div class="content">
          <div class="left hidden-sm-and-down">
            <img src="@/assets/images/portin/service-left.png" alt="" />
          </div>
          <div class="right hidden-sm-and-down">
            <div class="rightBox">
              <ul>
                <li
                  :class="{ active: active == item.id }"
                  v-for="item in serviceItemList[0]"
                  :key="item.id"
                  @mouseenter="MouseFn(1, item.id)"
                  @mouseleave="MouseFn(2, item.id)">
                  <img :src="active == item.id ? item.imgUrl2 : item.imgUrl" alt="" />
                  <span v-html="item.name"></span>
                  <strong v-html="item.desc"></strong>
                  <p>{{ item.desc2 }}</p>
                </li>
              </ul>
            </div>
            <div class="rightBox">
              <ul>
                <li
                  :class="{ active: active == item.id }"
                  v-for="item in serviceItemList[1]"
                  :key="item.id"
                  @mouseenter="MouseFn(1, item.id)"
                  @mouseleave="MouseFn(2, item.id)">
                  <img :src="active == item.id ? item.imgUrl2 : item.imgUrl" alt="" />
                  <span v-html="item.name"></span>
                  <strong v-html="item.desc"></strong>
                </li>
              </ul>
            </div>
          </div>
          <div class="right hidden-sm-and-up">
            <div class="rightBox">
              <template v-for="item in [...serviceItemList[0], ...serviceItemList[1]]">
                <span v-if="item.id > 1" class="line" :key="item.id"></span>
                <li :class="{ active: active == item.id }" :key="item.id + 1">
                  <img :src="item.imgUrl3" alt="" />
                  <div>
                    <span v-html="item.name"></span>
                    <strong v-html="item.desc"></strong>
                    <p>{{ item.desc2 }}</p>
                  </div>
                </li>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serviceItemList: [
        [
          {
            id: 11,
            name: '无限基础流量',
            desc: '再也不用担心流量超出啦，5G·4GLTE流量用完后，<br />将会转用基础流量（128kbps）',
            imgUrl: require('@/assets/images/24students/servise1.svg'),
            imgUrl2: require('@/assets/images/24students/servise1-1.svg'),
            imgUrl3: require('@/assets/images/24students/phone/servise1.svg')
          },
          {
            id: 22,
            name: '无限中美通话、短信',
            desc: '随心所欲跟国内亲人好友煲电话粥，</br>妈妈再也不用心疼国际话费',
            imgUrl: require('@/assets/images/24students/servise2.svg'),
            imgUrl2: require('@/assets/images/24students/servise2-2.svg'),
            imgUrl3: require('@/assets/images/24students/phone/servise2.svg')
          }
        ],
        [
          {
            id: 33,
            name: '无限美国通话、<br />全球短信',
            desc: '美国通话无限打，全球短信随心发',
            imgUrl: require('@/assets/images/24students/servise3.svg'),
            imgUrl2: require('@/assets/images/24students/servise3-3.svg'),
            imgUrl3: require('@/assets/images/24students/phone/servise3.svg')
          },
          {
            id: 44,
            name: '免费Wi-Fi Calling',
            desc: '回国探亲也能 <br />接收美国电话、短信',
            imgUrl: require('@/assets/images/24students/servise4.svg'),
            imgUrl2: require('@/assets/images/24students/servise4-4.svg'),
            imgUrl3: require('@/assets/images/24students/phone/servise4.svg')
          },
          {
            id: 55,
            name: '免费的移动热点',
            desc: '随时给电脑开热点<br />——咖啡厅工作的最佳伴侣',
            imgUrl: require('@/assets/images/24students/servise5.svg'),
            imgUrl2: require('@/assets/images/24students/servise5-5.svg'),
            imgUrl3: require('@/assets/images/24students/phone/servise5.svg')
          }
        ]
      ],
      active: 0
    };
  },
  methods: {
    MouseFn(type, id) {
      if (type == 1) {
        this.active = id;
      } else {
        this.active = 0;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import url(./style/ServiceItems.less);
</style>
